<template>
    <!-- Text Banner -->
    <div class="flex flex-col w-full bg-sub-200 items-center py-14 px-4 text-center">
        <p class="font-bold new_md:text-3xl text-xl text-text-0">자체 서비스 기획부터출시까지
            <br class="block new_md:hidden" />
            경험 및 고도화 경험</p>
        <p class="font-medium new_md:text-xl text-sm text-text-1 text-center mt-4 leading-[145%] tracking-[-0.0045em]">
            큐밋(QA전문 아웃소싱 플랫폼)
            <br class="block new_md:hidden" />겟아이즈(현명한 소비 플랫폼),  등 서비스를
            <br/>
            직접 기획·개발·운영한 경험을 기반으로출시 후 비즈니스까지 고려한 구조적인 개발 전략을 제공합니다.
        </p>
    </div>
</template>

<script>
export default {
    name: 'TextBanner'
}
</script>
